export type SqlSearchViewMode = 'table' | 'tile';

export const DEFAULT_SQL_EDITOR_QUERY = 'SELECT 1 AS ok';
export const DEFAULT_SQL_VIEW_MODE: SqlSearchViewMode = 'table';
export const SQL_PREVIEW_COLUMN_PREFIX = '__sql_preview_';
